<template>
  <div class="text-center">
    <h1>
      Accès non autorisé
    </h1>
    <div>
      <p>
        Vous n'avez pas accès à l'application Culturial
      </p>
      <AgrButton
        class="ma-5"
        outlined
        @click="onLogout()"
      >
        <v-icon>mdi-power</v-icon>
        Se déconnecter
      </AgrButton>
    </div>
  </div>
</template>
<script>
import { AgrButton } from '@agrial/ui'
import { mapActions } from 'vuex'
export default {
  name: 'NotAuthorize',
  components: { AgrButton },
  methods: {
    ...mapActions({
      logout: 'session/logout',
      resetUser: 'user/reset'
    }),
    onLogout () {
      this.logout().finally(() => {
        this.resetUser()
        this.$router.push({ name: 'login' })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.text-center {
  position: relative;
  top: 40%;
}
</style>
